interface IChartSize {
  height: number;
  width: number;
}
export function getChartSize(chart: HTMLDivElement): IChartSize {
  const parent = chart;
  const parentStyle = getComputedStyle(parent.parentElement);
  const parentWidth = parseInt(parentStyle.paddingLeft, 10) + parseInt(parentStyle.paddingRight, 10);
  const parentHeight = parseInt(parentStyle.paddingTop, 10) + parseInt(parentStyle.paddingBottom, 10);
  const parentSize = {
    height: parseInt(parentStyle.height, 10) - parentHeight,
    width: parseInt(parentStyle.width, 10) - parentWidth
  };
  return parentSize;
}



// WEBPACK FOOTER //
// ./src/app/modules/stats/charts/chartUtils.ts